import { InfoCircleOutline } from '../../../../../components/icons';
import { Avatar, Tooltip } from 'antd';
import useConnectedAccountOverview from '../../../../../customhooks/useConnectedAccountOverview';
import { getBanks } from 'banks-ng';
import { useMemo } from 'react';
import { formatCurrency } from '../../../../../utils/helper';

const banks = getBanks() as { name: string; logo: string }[];

const TotalBalanceCard = () => {
    const { overview } = useConnectedAccountOverview();

    const bankLogoMap = useMemo(() => {
        const map = new Map();
        banks.forEach(({ name, logo }) => {
            map.set(name.toLowerCase(), logo);
        });
        return map;
    }, []);

    return (
        <div className='w-full bg-white border border-appcolorfaintnine rounded-[24px] py-5 px-6 flex flex-col justify-between'>
            <div className='text-gray700 text-[18px]'>
                <div className='mb-4'>Total Balance</div>
                <div className='text-gray700 text-[30px] font-semibold'>
                    {formatCurrency(overview?.currentBalance ?? 0, 'NGN')}
                </div>
            </div>
            <div className='flex justify-start gap-10'>
                <div>
                    <Tooltip
                        placement='topLeft'
                        title={
                            'The current balance across all your connected bank accounts'
                        }
                    >
                        <p className='text-gray700 text-[12px] flex gap-[4px] items-center'>
                            Current Balance <InfoCircleOutline />
                        </p>
                    </Tooltip>
                    <div className='text-gray700 text-[18px] font-semibold'>
                        {formatCurrency(overview?.currentBalance ?? 0, 'NGN')}
                    </div>
                </div>

                <div>
                    <Tooltip
                        placement='topLeft'
                        title={
                            'The opening balance across all your connected bank accounts'
                        }
                    >
                        <p className='text-gray700 text-[12px] flex gap-[4px] items-center'>
                            Opening Balance <InfoCircleOutline />
                        </p>
                    </Tooltip>
                    <div className='text-gray700 text-[18px] font-semibold'>
                        {formatCurrency(overview?.openingBalance ?? 0, 'NGN')}
                    </div>
                </div>
            </div>

            <div>
                <div className='mb-2'>Connected Banks</div>
                <div className='flex justify-start gap-2'>
                    {overview?.banks?.map((name, index) => (
                        <Avatar
                            key={index}
                            src={bankLogoMap.get(name.toLowerCase())}
                            style={{
                                border: '1px solid #D0D5DD',
                                background: 'transparent'
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TotalBalanceCard;
